"use strict";
(self["__LOADABLE_LOADED_CHUNKS__"] = self["__LOADABLE_LOADED_CHUNKS__"] || []).push([[8383],{

/***/ 4570:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var helpers_devicePx__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(48073);

const scrollToElement = (elementOrSelector, options)=>{
    const { compensation = 0, smooth = false, onlyUp = false, scrollableElement } = options || {};
    const element = typeof elementOrSelector === "string" ? document.querySelector(elementOrSelector) : elementOrSelector;
    if (element) {
        const container = scrollableElement || window;
        const offset = scrollableElement ? scrollableElement.scrollTop : window.scrollY;
        const elementRect = element.getBoundingClientRect();
        const elementOffsetTop = elementRect.top + offset;
        const offsetTop = elementOffsetTop + (0,helpers_devicePx__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(compensation) || 0;
        if (onlyUp && offset <= elementOffsetTop) {
            return;
        }
        if (smooth) {
            try {
                container.scroll({
                    top: offsetTop,
                    left: 0,
                    behavior: "smooth"
                });
            } catch (err) {
                container.scroll(0, offsetTop);
            }
        } else {
            container.scroll(0, offsetTop);
        }
    } else {
        console.warn(`Element '${elementOrSelector}' not found`);
    }
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (scrollToElement);


/***/ }),

/***/ 50556:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ constants)
});

;// CONCATENATED MODULE: ./src/helpers/constants/localStorageNames.ts
/* harmony default export */ const localStorageNames = ({
    shippingFormValues: "shippingFormValues",
    authGender: "authGender",
    authEmail: "authEmail",
    quizFlowSteps: "quizFlowSteps",
    claimedGiftCard: "claimedGiftCard",
    queuePendingProducts: "queuePendingProducts",
    queueHighPriorityProducts: "queueHighPriorityProducts",
    queueLowPriorityProducts: "queueLowPriorityProducts",
    stockNotificationSubscriptionProductId: "stockNotificationSubscriptionProductId",
    lastAddedToCartProductMetadata: "lastAddedToCartProductMetadata",
    iterableOptInPendingProjects: "iterableOptInPendingProjects",
    lastAnalyticsPageEventTime: "lastAnalyticsPageEventTime",
    giftWithSpendThresholdShown: "giftWithSpendThresholdShown",
    cartSubscriptionBanner: "isCartSubscriptionBannerShown"
});

;// CONCATENATED MODULE: ./src/helpers/constants/cookieNames.ts
/* harmony default export */ const cookieNames = ({
    featuresOverride: "scnt_features_override",
    abTestsOverride: "scnt_abtests_override",
    cacheOverride: "scnt_cache",
    mixpanelSuperProperties: "scnt_mixpanel_super_props",
    resubscribeOffer: "resubscribeOffer",
    e2eTest: "scnt_e2e_test",
    isPutFirstInQueueModalShown: "isPutFirstInQueueModalShown",
    isResubscribePromoModalShown: "isAdditionalResubscribeModalShown",
    isCardUpdateModalShown: "isCardUpdateModalShown",
    isAddToCartCaseUpsellModalShown: "isAddToCartCaseUpsellModalShown",
    isAddToQueueCaseUpsellModalShown: "isAddToQueueCaseUpsellModalShown",
    isHereticCaseUpsellModalShown: "isHereticCaseUpsellModalShown",
    /**
   * Subscription flow cookies, should be removed after subscribe
   */ // UTM for dataLayer: should exist until subsribe
    utmMediumBeforeSubscription: "utmMediumBeforeSubscription",
    utmSourceBeforeSubscription: "utmSourceBeforeSubscription",
    // UTM for useFlow
    utmMediumSession: "utmMediumSession",
    utmSourceSession: "utmSourceSession",
    fbPixelId: "fbPixelId",
    flowName: "flowName",
    synergyParams: "synergyParams",
    tophatterParams: "tophatterParams",
    // coupon cookies
    discountCoupon: "discountCoupon",
    appliedCouponCode: "appliedCouponCode",
    isFreeTrialCoupon: "isFreeTrialCoupon",
    country: "country",
    selectedPlan: "selectedPlan",
    referrerLandingPageURL: "referrerLandingPageURL",
    logoRedirectUrl: "logoRedirectUrl",
    // countdown cookies
    rootCountdown: "countdownCookie_root",
    freePerfumeCountdown: "countdownCookie_freePerfume",
    giftSubscriptionOfferCountdown: "countdownCookie_giftSubscriptionOffer",
    // postClick test target group
    postClickGroup: "postClickGroup",
    fromEmail: "fromEmail",
    giftSubscriptionOffer: "giftSubscriptionOffer"
});

;// CONCATENATED MODULE: ./src/helpers/constants/features.ts
const features = {
    theShop: "theShop",
    candleSubscription: "candleSubscription",
    fragranceFamiliesPage: "fragranceFamiliesPage",
    noteLibPages: "noteLibPages",
    addQuebecToCanada: "addQuebecToCanada",
    wallet: "wallet",
    defaultCoupon50: "defaultCoupon50",
    jasonWuGwp: "JasonWuGwp",
    scentPreferences: "scentPreferences",
    theEdit: "theEdit",
    candleClubMoreBanners: "candleClubMoreBanners",
    partytown: "partytown",
    techCartContinueBar: "techCartContinueBar",
    collaborationSaks: "collaborationSaks",
    fillYourQueueSweepstakes: "fillYourQueueSweepstakes",
    optInPopups: "optInPopups",
    magicLinkWeb: "magicLinkWeb",
    cotyNYNJ: "cotyNYNJ",
    strapiBanners: "strapiBanners",
    giftHub: "giftHub",
    giftHubNotification: "giftHubNotification",
    holiday22SaleBadge15: "holiday22SaleBadge15",
    holiday22SaleBadge20: "holiday22SaleBadge20",
    holidayCatalogue: "holidayCatalogue",
    holiday22Sub60: "holiday22Sub60",
    holiday22CardUpdate60: "holiday22CardUpdate60",
    holiday22Resubscribe60: "holiday22Resubscribe60",
    giftSetProductPage: "giftSetProductPage",
    blackFridayTopHomePageBanner: "blackFridayTopHomePageBanner",
    cyberMondayTopHomePageBanner: "cyberMondayTopHomePageBanner",
    gwpSpecificSku: "gwpSpecificSku",
    gwpBuyYourQueue: "gwpBuyYourQueue",
    gwpSpendThreshold: "gwpSpendThreshold",
    gwpExcludeVials: "gwpExcludeVials",
    giftSubscriptionOffer: "giftSubscriptionOffer",
    holidayBannerUpdateV2: "holidayBannerUpdateV2",
    seoStrapi: "seoStrapi",
    cartEcommercePromos: "cartEcommercePromos",
    cacheForBots: "cacheForBots",
    // Website takeovers, `featuredBrand` prefix for brand page, `websiteTakeover` prefix for entry points
    strapiFeaturedBrand: "strapiFeaturedBrand",
    strapiWebsiteTakeover: "strapiWebsiteTakeover",
    attentiveCollectPhoneNumber: "attentiveCollectPhoneNumber",
    scentbirdPodcastEntryPoints: "scentbirdPodcastEntryPoints",
    scentHoroscope: "scentHoroscope",
    postClickVWO: "postClickVWO",
    faro: "faro",
    newrelicWeb: "newrelicWeb",
    shopSamples: "shopSamples",
    strapiDynamicPage: "strapiDynamicPage",
    mobileAppEntryPoint: "mobileAppEntryPoint",
    ssrApiCache: "ssrApiCache",
    saksGreyCase: "greyCaseForSaksGwp",
    saksWhiteCase: "whiteCaseForSaksGwp",
    hideCasesReviews: "hideCasesReviews",
    limitedDrops: "limitedDrops",
    coarPhysicalRebrand: "coarPhysicalRebrand",
    holidayMothersDay: "holidayMothersDay",
    driftEcommerce: "driftEcommerce",
    driftEcommercePromo: "driftEcommercePromo",
    driftEcommercePromoModal: "driftEcommercePromo",
    travelSizeFragrances: "travelSizeFragrances",
    strapiMainPageBanners: "strapiMainPageBanners",
    holidayFathersDay: "holidayFathersDay",
    budgieChatAssistance: "budgieChatAssistance",
    caseUpsellAddToCart: "caseUpsellAddToCart",
    caseUpsellAddToQueue: "caseUpsellAddToQueue",
    caseUpsellHeretic: "caseUpsellHeretic",
    memorialSale: "memorialSale",
    strapiPromoCard: "strapiPromoCard",
    coarShopPage: "coarShopPage",
    coarTarotGWP: "coarTarotGWP",
    hideGoogleAuth: "hideGoogleAuth",
    driftSubscription: "driftSubscription",
    driftSubscriptionLaunchPromo: "driftSubscriptionLaunchPromo",
    cheqAi: "cheqAi",
    osano: "osano",
    sri: "sri",
    scentbirdAcademy: "scentbirdAcademy",
    scentbirdAcademyLaunchPromo: "scentbirdAcademyLaunchPromo",
    ecommerceTwoZero: "ecommerceTwoZero",
    saleEcommerceFilter: "saleEcommerceFilter",
    gwpByqOctober2023: "gwpByqOctober2023",
    giftsUnder50Page: "giftsUnder50Page",
    gwpByqHoliday2023: "gwpByqHoliday2023",
    buy5pay4: "buy5pay4",
    twelveDaysPage: "twelveDaysPage",
    bfcmNotification: "bfcmNotification",
    giftSubscriptionNotification: "giftSubscriptionNotification",
    strapiCareersPage: "strapiCareersPage",
    giftHubValentinesNotificationMessage: "giftHubValentinesNotificationMessage",
    // This section will only be used for growth book features
    hideCancelSubscriptionButton: "hide-cancel-subscription-button",
    applyPayWeb: "apple-pay-web",
    noPaginationForBots: "no-pagination-for-bots",
    aaTestPdp: "aa-test-pdp",
    aaUserNav: "aa-user-nav",
    giftCode50PromoCard: "gift-code-50-promo-card",
    giftHubHeaderBanner: "gift-hub-header-banner",
    valentinesHeaderBanner: "valentines-header-banner",
    headerBannerVisibleOnGiftHub: "header-banner-visible-on-gift-hub",
    strapiCoarPage: "strapi-coar-page"
};
/* harmony default export */ const constants_features = (features);

;// CONCATENATED MODULE: ./src/helpers/constants/abTests.ts
// ATTN we use these constants in data dump
const abTests = {
    upchargeInfoPayment: "UpchargeInfoPayment",
    mainStorylyForLeads: "main:storylyForLeads",
    mainAddCaseNextShipment: "main:addCaseNextShipment",
    paymentPlanSelection: "payment:planSelectionRelaunchV2",
    paymentSafeCheckoutRedesign: "payment:safeCheckoutRedesign",
    paymentQueueEditPopup: "payment:queueEditPopup",
    homeNewHowItWorks: "home:newHowItWorks",
    homeStickyCtaWithQueue: "home:stickyCtaWithQueue",
    homeBrandsRowWithBottles: "home:brandsRowWithBottles",
    spStepsFlow: "sp:stepsFlow",
    spReviewsBanner: "sp:reviewsBanner",
    spWhatYouGetSection: "sp:whatYouGetSection",
    ecomCartStickyCta: "ecom:cartStickyCta",
    pdpAddToQueueRedirect: "pdp:addToQueueRedirect",
    statusUpgradeCopyUpdate: "status:upgradeCopyUpdate",
    tyQueueRedirect: "ty:queueRedirect",
    queueHeaderCounter: "queue:headerCounter",
    queueStickyBanner: "queue:stickyBanner",
    queueCaseSubscriptionBanner: "queue:CaseSubscriptionBanner",
    cancelButton: "cancelButton25",
    csBadge: "cs:badge",
    csStickyVideo: "cs:stickyVideo",
    csShorterFlow: "cs:shorterFlow",
    candleStickyVideo: "candle:stickyVideo",
    candleDiscountBadge: "candle:discountBadge",
    candleDriftConfirmationPopup: "candle:drift:confirmationPopup",
    burgerMenu: "burgerMenu",
    homeCanada50vs60: "home:canada50vs60",
    upgradeEntryPoints: "upgradeEntryPoints",
    burgerMenuBannersForLeads: "burgerMenuBannersForLeads",
    burgerMenuBannersForActive: "burgerMenuBannersForActive",
    upgradePopup: "upgradePopup",
    driftbrandpage: "driftbrandpage",
    navScentHoroscopeInPerfumes: "nav:scentHoroscopeInPerfumes",
    caseUpsellOptions12vs3: "caseUpsellOptions12vs3",
    limitedDropsCheckoutRedirect: "limitedDropsCheckoutRedirect",
    cartNotificationDesignUpdate: "cart:notificationDesignUpdate",
    pdpSubscribeOfferAnimatedCountdown: "pdp:subscribeOfferAnimatedCountdown",
    homeFooterSeoKeyword: "home:footerSeoKeyword",
    resubscribeLandingVsMain: "resub:landingVsMain",
    imgproxy: "imgproxy",
    queueNotificationLandToQueuePage: "queue:notificationLandToQueuePage",
    recommendedForYouNavLink: "nav:recommendedForYouNavLink",
    applePay: "payment:applePay"
};
/* harmony default export */ const constants_abTests = (abTests);

;// CONCATENATED MODULE: ./src/helpers/constants/businessLogic.ts
/* harmony default export */ const businessLogic = ({
    maxCountOfPaymentMethods: 9,
    maxCountOfShippingAddresses: 5
});

;// CONCATENATED MODULE: ./src/helpers/constants/iterateHq.ts
/* harmony default export */ const iterateHq = ({
    purchaseSurvey: {
        US: "5baba07d2121cf00011a6be2",
        CA: "613741e24538820001a90c3e"
    }
});

;// CONCATENATED MODULE: ./src/helpers/constants/externalLinks.ts
/* harmony default export */ const externalLinks = ({
    scentbirdBlog: "https://www.scentbird.com/blog/perfume-subscription/",
    scentbirdPodcast: "https://podcast.scentbird.com/",
    driftHowItWorksVideo: "https://www.youtube.com/embed/bdQqwYSS0Jw",
    cleanFragrancesVideo: "https://www.youtube.com/embed/Eq3QgPb5GY0",
    ripplingJobs: "https://ats.rippling.com/scentbird/jobs"
});

;// CONCATENATED MODULE: ./src/helpers/constants/discounts.ts
// possible discounts
/* harmony default export */ const discounts = ({
    buy5pay4: "buy5pay4"
});

;// CONCATENATED MODULE: ./src/helpers/constants/index.ts








/* harmony default export */ const constants = ({
    localStorageNames: localStorageNames,
    cookieNames: cookieNames,
    features: constants_features,
    abTests: constants_abTests,
    businessLogic: businessLogic,
    iterateHq: iterateHq,
    externalLinks: externalLinks,
    discounts: discounts
});


/***/ }),

/***/ 48073:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// converts iPhone XR size in pixels to vwx device size
const devicePx = (value)=>{
    if (typeof window !== "undefined" && typeof window.__DEVICE__ !== "undefined" && typeof window.innerWidth === "number") {
        // TODO add cache here - added on 2021-10-20 by maddoger
        const multiplier = window.__DEVICE__.isMobile && !window.__DEVICE__.isTablet ? window.innerWidth * 0.0024155 : 1;
        return Math.round(value * multiplier);
    }
    return value;
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (devicePx);


/***/ }),

/***/ 83901:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Mu: () => (/* binding */ PaymentTokenError),
/* harmony export */   P6: () => (/* binding */ CausedError),
/* harmony export */   _R: () => (/* binding */ SilentError),
/* harmony export */   __: () => (/* binding */ GraphQLError),
/* harmony export */   as: () => (/* binding */ CancelledPromiseError),
/* harmony export */   gK: () => (/* binding */ UserError),
/* harmony export */   nl: () => (/* binding */ ServerError),
/* harmony export */   p8: () => (/* binding */ ValidationError),
/* harmony export */   wY: () => (/* binding */ processError)
/* harmony export */ });
/* harmony import */ var links__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69541);
/* harmony import */ var logger__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(58738);
/* harmony import */ var compositions_modals_ErrorModal_ErrorModal__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(53313);



// if you need to cancel the promise and break the flow, you can throw this error
class CancelledPromiseError extends Error {
    constructor(message = "CancelledPromiseError"){
        super(message);
    }
}
// error with a new message but with cause inside
class CausedError extends Error {
    cause;
    constructor(cause, message){
        if (message) {
            super(message);
        } else if (typeof cause === "string") {
            super(cause);
        } else {
            super(cause?.message || "Unknown error");
        }
        this.cause = cause;
    }
}
// error with user message and reason
class ValidationError extends CausedError {
    constructor(cause, message = "ValidationError"){
        super(cause, message);
    }
}
// error for internal use only, it will be logged, but will not be in notification
class SilentError extends CausedError {
}
// error with user message and reason
class UserError extends CausedError {
}
// special class for server errors, when users shouldn't see the actual error
class ServerError extends CausedError {
}
// special class for graphql error, it is based on ServerError because it shouldn't be shown to a user
class GraphQLError extends ServerError {
}
// special class for recurly errors
class PaymentTokenError extends UserError {
}
// this function helps to process different errors and eliminate code duplication
// TODO think about isomorthic implementation (to provide redirect from server, something instead of openModal, etc) - added on 08.02.2022 by sonatskiy
const processError = (error, infoMessage)=>{
    if (infoMessage) {
        logger__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z.info(error, infoMessage);
    }
    if (error instanceof CancelledPromiseError) {
        logger__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z.info(error);
        return;
    }
    if (error instanceof ValidationError) {
        // do nothing, usually it's a form validation
        return;
    }
    if (error instanceof SilentError) {
        logger__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z.info(error);
        return;
    }
    if (error instanceof UserError) {
        if ( true && error.cause?.securityErrorCode === "NOT_AUTHENTICATED") {
            const url = `${links__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP.login}?redirect=${encodeURIComponent(window.location.pathname + window.location.search)}`;
            window.location.assign(url);
            return;
        }
        if (error.cause?.changePlanErrorCode === "CHANGE_PLAN_DISABLED") {
            (0,compositions_modals_ErrorModal_ErrorModal__WEBPACK_IMPORTED_MODULE_2__/* .openChangePlanErrorModal */ ._8)(error.cause.action);
            return;
        }
        if (!infoMessage) {
            logger__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z.warn(error);
        }
        if (true) {
            (0,compositions_modals_ErrorModal_ErrorModal__WEBPACK_IMPORTED_MODULE_2__/* .openErrorModal */ .yQ)({
                message: error.message
            });
        }
        return;
    }
    if (error.networkError) {
        if (!infoMessage) {
            logger__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z.info(error);
        }
        if (true) {
            if (error?.networkError?.statusCode === 451) {
                (0,compositions_modals_ErrorModal_ErrorModal__WEBPACK_IMPORTED_MODULE_2__/* .openFraudModal */ .mr)();
                return;
            }
            (0,compositions_modals_ErrorModal_ErrorModal__WEBPACK_IMPORTED_MODULE_2__/* .openNetworkErrorModal */ .Xv)();
        }
        return;
    }
    logger__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z.error(error);
    if (true) {
        (0,compositions_modals_ErrorModal_ErrorModal__WEBPACK_IMPORTED_MODULE_2__/* .openServerErrorModal */ .pC)();
    }
};


/***/ }),

/***/ 67525:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var date__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(64895);
/* harmony import */ var cookie_storage__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83913);


// special helper to check visibility conditions based on cookie
const checkUpsellModalCookie = (options)=>{
    const { cookieName, countPerDay } = options;
    const cookie = cookie_storage__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP.getItem(cookieName);
    const { startDate, count = 0 } = cookie || {};
    // flag if modal should be visible based on timing condition
    let isVisible = false;
    // onClose handler to track a show
    let onClose = null;
    // we show 3 times each 24 hours. 24 hours starts from the first show
    if (count < countPerDay || (0,date__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)().diff((0,date__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(startDate), "hours") > 24) {
        isVisible = true;
        onClose = ()=>{
            cookie_storage__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP.setItem(cookieName, {
                startDate: count === 0 || count >= countPerDay ? (0,date__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)().toISOString() : startDate,
                count: count >= countPerDay ? 1 : count + 1
            });
        };
    }
    return {
        isVisible,
        onClose
    };
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (checkUpsellModalCookie);


/***/ }),

/***/ 74017:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   ZP: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* unused harmony exports queryCoupons, queryMultiPlanCoupons */
const queryCoupons = {
    c1: "HD15",
    c2: "HD25",
    c3: "HD30",
    c4: "HD40",
    c5: "HD50",
    c6: "HD60",
    cfr: "FREE_TRIAL",
    none: null
};
const queryMultiPlanCoupons = {
    c2: "HD25CRO",
    c5: "HD50CRO"
};
const getCouponFromQueryParams = (queryCoupon, isMultiPlansEnabled)=>{
    const defaultCoupon = queryCoupons[queryCoupon];
    if (isMultiPlansEnabled) {
        return queryMultiPlanCoupons[queryCoupon] || defaultCoupon;
    }
    return defaultCoupon;
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (getCouponFromQueryParams);


/***/ }),

/***/ 72448:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
const getElementPosition = (node)=>{
    const box = node.getBoundingClientRect();
    const body = document.body;
    const docEl = document.documentElement;
    const scrollTop = window.pageYOffset || docEl.scrollTop || body.scrollTop;
    const scrollLeft = window.pageXOffset || docEl.scrollLeft || body.scrollLeft;
    const clientTop = docEl.clientTop || body.clientTop || 0;
    const clientLeft = docEl.clientLeft || body.clientLeft || 0;
    const top = box.top + scrollTop - clientTop;
    const left = box.left + scrollLeft - clientLeft;
    return {
        top: Math.round(top),
        left: Math.round(left)
    };
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (getElementPosition);


/***/ }),

/***/ 96543:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
const focusableElements = `
  a[href]:not([disabled]), 
  button:not([disabled]), 
  input[type="text"]:not([disabled]),
  input[type="radio"]:not([disabled]), 
  input[type="checkbox"]:not([disabled]), 
  textarea:not([disabled]), 
  select:not([disabled]),
  div[role="button"]:not([disabled])
`;
const getFocusableChildren = (element)=>element.querySelectorAll(focusableElements);
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (getFocusableChildren);


/***/ }),

/***/ 6528:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
const microDataAttrs = [
    "itemID",
    "itemProp",
    "itemRef",
    "itemScope",
    "itemType"
];
const selectAttrs = [
    "autoComplete",
    "disabled",
    "multiple",
    "required"
];
const inputAttrs = [
    ...selectAttrs,
    "enterKeyHint",
    "inputMode",
    "list",
    "min",
    "max",
    "readOnly",
    "step",
    "type"
];
const textareaAttrs = [
    "required",
    "disabled",
    "readOnly",
    "rows",
    "cols"
];
const commonAttributes = [
    "accessKey",
    "autoFocus",
    "hidden",
    "lang",
    "name",
    "role",
    "spellCheck",
    "style",
    "tabIndex",
    "translate"
];
const allAttributes = new Set([].concat(microDataAttrs, inputAttrs, textareaAttrs, commonAttributes));
const getGlobalHtmlAttrs = (props)=>Object.keys(props).reduce((attrs, key)=>{
        if (// Aria
        key.startsWith("aria-") || key.startsWith("data-") || allAttributes.has(key)) {
            attrs[key] = props[key];
        }
        return attrs;
    }, {});
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (getGlobalHtmlAttrs);


/***/ }),

/***/ 80141:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
const getPlanDifferencePercent = (selectedPlanProductPrice, productPrice)=>{
    if (!selectedPlanProductPrice) {
        return null;
    }
    const discount = Math.round(100 * (selectedPlanProductPrice - productPrice) / selectedPlanProductPrice);
    return discount > 0 ? `${discount}%` : null;
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (getPlanDifferencePercent);


/***/ }),

/***/ 89025:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var config__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1655);

const getReferrerLandingPageUrl = (path)=>{
    const host = config__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z.publicUrl.replace(/^https:\/\/(www\.)?/, "");
    const pathname = /^\/referral\//.test(path) ? path.replace(/scentbirduser.+/, "") : path;
    return `${host}${pathname}`;
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (getReferrerLandingPageUrl);


/***/ }),

/***/ 78430:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
const cleanParams = (input)=>Object.keys(input).reduce((result, key)=>{
        result[key] = input[key] ? String(input[key]).trim() || "" : "";
        return result;
    }, {});
const formatStreetApt = (street1, street2, isCanada)=>{
    if (!street1 || !street2) {
        return street1 || street2;
    }
    const isNumber = /^\d+$/.test(street2);
    // in case of apt is just a number
    if (isNumber) {
        return isCanada ? `${street2}-${street1}` : `${street1} #${street2}`;
    }
    // in case of apt includes words - APT, ROOM, FLOOR, BOX, etc.
    return isCanada ? `${street2}, ${street1}` : `${street1}, ${street2}`;
};
const formatAddress = function(address) {
    let { regionOnNewLine } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (!address || !Object.keys(address).length) {
        return "";
    }
    const { street1, street2, city, region, postalCode, country } = cleanParams(address);
    const isCanada = country === "CA" || country === "Canada";
    const streetAndCity = [
        formatStreetApt(street1, street2, isCanada),
        city
    ].filter(Boolean).join(", ");
    const stateWithZip = [
        regionOnNewLine ? "<br />" : "",
        region,
        postalCode
    ].filter(Boolean).join(" ");
    return [
        streetAndCity,
        stateWithZip,
        country
    ].filter(Boolean).join(", ");
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (formatAddress);


/***/ }),

/***/ 49284:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
const formatFullName = (param)=>{
    let { firstName = "", lastName = "" } = param;
    if (firstName && lastName) {
        return `${firstName} ${lastName}`;
    }
    if (!firstName && !lastName) {
        return `Scentbird Account`;
    }
    return firstName || lastName;
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (formatFullName);


/***/ }),

/***/ 72160:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
const formatPrice = function() {
    let value = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, opts = arguments.length > 1 ? arguments[1] : void 0;
    const { isCents = true, withCurrency = true, toFixed = 2, removeZeroCents = false } = opts || {};
    const modifier = value < 0 ? "- " : "";
    const currency = withCurrency ? "$" : "";
    let formattedValue = Math.abs(isCents ? value / 100 : value).toFixed(toFixed);
    if (removeZeroCents) {
        formattedValue = formattedValue.replace(".00", "");
    }
    return `${modifier}${currency}${formattedValue}`;
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (formatPrice);


/***/ }),

/***/ 80921:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var core_js_modules_es_array_push_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85183);
/* harmony import */ var core_js_modules_es_array_push_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_push_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _formatPrice__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(72160);


const formatProductLabelsForAnalytics = (product)=>{
    if (!product) {
        return [];
    }
    const { rebrandLabels, upchargePrice } = product;
    let result = [];
    if (rebrandLabels) {
        Object.keys(rebrandLabels).forEach((type)=>{
            if (Array.isArray(rebrandLabels[type])) {
                rebrandLabels[type].forEach((label)=>{
                    if (label === "UPCHARGE") {
                        return;
                    }
                    result.push(label);
                });
            }
        });
    }
    if (upchargePrice) {
        result.push(`UPCHARGE +${(0,_formatPrice__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(upchargePrice, {
            removeZeroCents: true
        })}`);
    }
    return result;
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (formatProductLabelsForAnalytics);


/***/ }),

/***/ 86478:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
const formatSize = (volume, unit)=>{
    if (!volume || unit === "pcs") {
        return "";
    }
    return `${volume} ${unit}`;
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (formatSize);


/***/ }),

/***/ 5657:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   I: () => (/* binding */ getAddItemProduct),
/* harmony export */   J: () => (/* binding */ getTradingItem)
/* harmony export */ });
/* harmony import */ var _formatProductLabelsForAnalytics__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(80921);

// you should pass selected trading item
const getAddItemProduct = (props)=>{
    const { product, tradingItem, override, isDrift = false, isStarterSet = false } = props;
    const { id, image, rebrandImage, name, brandInfo: { name: brand }, category, gender, upchargePrice, isSubscribedToStockNotification, theEdit } = product;
    const { volume, section, productGroup, type } = tradingItem || {};
    const isLimitedDrop = section === "LimitedDrop";
    const isFullSizeBottle = type === "PerfumeBottle";
    const isVial = productGroup === "Perfume" && !isFullSizeBottle;
    const is1_5mlVial = isVial && volume?.volume === 1.5 && volume?.unit === "ml";
    const isRefill = product.type === "CarFreshenerRefill" && !isStarterSet;
    const isAcademyCourse = productGroup === "AcademyCourse";
    return {
        productId: id,
        tradingItemId: tradingItem?.id,
        name,
        brand,
        category,
        gender,
        image,
        rebrandImage,
        productLabels: (0,_formatProductLabelsForAnalytics__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(product),
        upchargePrice,
        isLimitedEdition: tradingItem?.isLimitedEdition,
        isSubscribedToStockNotification,
        theEdit,
        isLimitedDrop,
        isDrift,
        isStarterSet,
        isVial,
        is1_5mlVial,
        isRefill,
        isAcademyCourse,
        ...override
    };
};
// helps to get required trading item in Product Card
const getTradingItem = (props)=>{
    const { product, isEcommerce, isFullSizeBottlePrioritized } = props;
    const { tradingItems } = product;
    const subscriptionTradingItem = tradingItems?.items?.find((param)=>{
        let { section } = param;
        return section === "Subscription";
    });
    const regularEcommerceTradingItem = tradingItems?.items?.filter((param)=>{
        let { type } = param;
        return type !== "ALaCarteAcademyCourseKit";
    }).find((param)=>{
        let { section } = param;
        return section !== "Subscription";
    });
    const fullSizeBottleTradingItem = isFullSizeBottlePrioritized && tradingItems?.items?.find((param)=>{
        let { section, type } = param;
        return section === "Ecommerce" && type === "PerfumeBottle";
    });
    /*
  * FullSize bottle has the highest priority.
  * Then depending on isEcommerce it can be ecommerce item or subscription item.
  * For product cards isEcommerce is false
  * */ const tradingItem = fullSizeBottleTradingItem || (isEcommerce ? regularEcommerceTradingItem : subscriptionTradingItem || regularEcommerceTradingItem);
    const isEcommerceProduct = tradingItem?.section !== "Subscription";
    const isAcademyCourse = tradingItem?.type === "ALaCarteAcademyCourse";
    return {
        tradingItem,
        isEcommerceProduct,
        isAcademyCourse
    };
};


/***/ }),

/***/ 40638:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
const getTestIdFromText = function() {
    for(var _len = arguments.length, messages = new Array(_len), _key = 0; _key < _len; _key++){
        messages[_key] = arguments[_key];
    }
    return messages.reduce((acc, message, messageIndex)=>{
        const inputText = typeof message === "string" ? message : message.en;
        const formattedText = inputText.replace(/(?:^\w|[A-Z]|[-_]\w|\b\w|\s+\w)/g, (match, matchIndex)=>!matchIndex && !messageIndex ? match.toLowerCase() : match.replace(/[-_\s]/, "").toUpperCase());
        return acc + formattedText;
    }, "");
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (getTestIdFromText);


/***/ }),

/***/ 88154:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
const replaceMap = {
    "<": "\\u003c",
    ">": "\\u003e"
};
const safeJsonStringify = (object)=>{
    return JSON.stringify(object).replace(/[<>]/g, (c)=>replaceMap[c]);
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (safeJsonStringify);


/***/ }),

/***/ 43615:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
const map = new Map([
    [
        "&lt;",
        "<"
    ],
    [
        "&gt;",
        ">"
    ],
    [
        "&quot;",
        '"'
    ],
    [
        "&apos;",
        "'"
    ],
    [
        "&amp;",
        "&"
    ],
    [
        "&nbsp;",
        " "
    ],
    [
        "&nbsp",
        " "
    ]
]);
// removes all html instances from the string like &nbsp; and br
// ATTN do NOT use with user-input data. It covers only small amount of cases. Use for messages only
const sanitizeForAnalytics = (input)=>{
    if (!input || typeof input !== "string") {
        return input;
    }
    let result = input;
    // replace all html tags
    result = result.replace(/<([^<>]*?)>/g, " ");
    // replace html entities
    map.forEach((to, from)=>{
        result = result.replaceAll(from, to);
    });
    // replace repeating spaces
    result = result.replace(/\n\r/g, " ").replace(/\s{2,}/g, " ").trim();
    return result;
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (sanitizeForAnalytics);


/***/ }),

/***/ 92947:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var xss__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(76479);
/* harmony import */ var xss__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(xss__WEBPACK_IMPORTED_MODULE_0__);

// very strict, remove every tag
const defaultOptions = {
    whiteList: {
        br: []
    },
    stripIgnoreTag: false
};
const sanitizeHtml = function(source) {
    let options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : defaultOptions;
    return xss__WEBPACK_IMPORTED_MODULE_0___default()(source, options);
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (sanitizeHtml);


/***/ }),

/***/ 12404:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
const sanitizeRedirectUrl = (url)=>{
    if (!url) {
        return url;
    }
    // remove domain from the url, because we can redirect only to our domain
    const sanitized = url.replace(/^([a-z]*?):?\/\/([^\/?]*)([\/?]?)/gi, "$3");
    // reset invalid urls
    if (!sanitized) {
        return null;
    }
    const firstChar = sanitized.charAt(0);
    if (firstChar !== "/" && firstChar !== "?") {
        return null;
    }
    return sanitized;
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (sanitizeRedirectUrl);


/***/ }),

/***/ 95820:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/**
 * Generates array of numbers from the beggining to end
 * e.g range(1, 3) → [ 1, 2, 3 ]
 */ const range = (begin, end)=>{
    begin = Number(begin);
    end = Number(end);
    if (Number.isNaN(begin) || Number.isNaN(end)) {
        throw new Error("array.range accepts two aguments, both should be numbers");
    }
    const isDownwards = begin > end;
    const length = (isDownwards ? begin - end : end - begin) + 1;
    return new Array(length).fill(null).map((v, i)=>isDownwards ? begin - i : begin + i);
};
/**
 * Shuffles the array randomly
 * e.g [ 0, 1, 2, 3 ] → [ 2, 1, 0, 3 ]
 */ // TODO if return value is same as passed then do shuffle again
const shuffle = (array)=>{
    if (Array.isArray(array)) {
        let newArray = [
            ...array
        ];
        // if array is suit for shuffle, it's small enougth, return it right away
        if (newArray.length <= 1) {
            return newArray;
        }
        for(let i = newArray.length - 1; i > 0; i--){
            const j = Math.floor(Math.random() * (i + 1));
            [newArray[i], newArray[j]] = [
                newArray[j],
                newArray[i]
            ];
        }
        if (newArray.join() === array.join()) {
            newArray.reverse();
        }
        return newArray;
    }
    throw new Error("array.shuffle accepts only arrays in first argument");
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
    range,
    shuffle
});


/***/ }),

/***/ 98533:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/**
 * Converts hex color to HSL array
 * e.g '#E73DAC' → [ 321, 78, 57 ]
 */ const hexToHslArray = (hex)=>{
    let result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    let r = parseInt(result[1], 16) / 255;
    let g = parseInt(result[2], 16) / 255;
    let b = parseInt(result[3], 16) / 255;
    let max = Math.max(r, g, b);
    let min = Math.min(r, g, b);
    let h;
    let s;
    let l = (max + min) / 2;
    if (max === min) {
        h = 0;
        s = 0;
    } else {
        let d = max - min;
        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
        switch(max){
            case r:
                h = (g - b) / d + (g < b ? 6 : 0);
                break;
            case g:
                h = (b - r) / d + 2;
                break;
            case b:
                h = (r - g) / d + 4;
                break;
        }
        h /= 6;
    }
    h = Math.round(360 * h);
    s *= 100;
    s = Math.round(s);
    l *= 100;
    l = Math.round(l);
    return [
        h,
        s,
        l
    ];
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
    hexToHslArray
});


/***/ }),

/***/ 97723:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
const removeKeys = function(object) {
    for(var _len = arguments.length, keys = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        keys[_key - 1] = arguments[_key];
    }
    const copy = Object.assign({}, object);
    for (let key of keys){
        delete copy[key];
    }
    return copy;
};
const isObject = (item)=>{
    return item && typeof item === "object" && !Array.isArray(item);
};
/**
 * Deep merge of two objects
 *
 * If a key exists in both objects:
 * - and both values are objects, the two values will be recursively merged
 * - otherwise the value from the second object will be used
 *
 * e.g. { name: 'Fred', health: { age: 10 } }, { name: 'Freddy', health: { died: true } } → { name: 'Freddy', helath: { age: 10, died: true } }
 */ const deepmerge = (target, source)=>{
    if (!isObject(target) || !isObject(source)) {
        return target;
    }
    const copy = Object.assign({}, target);
    for (const key of Object.keys(source)){
        if (isObject(source[key]) && isObject(copy[key])) {
            copy[key] = deepmerge(copy[key], source[key]);
        } else {
            copy[key] = source[key];
        }
    }
    return copy;
};
const merge = function() {
    for(var _len = arguments.length, objects = new Array(_len), _key = 0; _key < _len; _key++){
        objects[_key] = arguments[_key];
    }
    return objects.reduce((prev, next)=>{
        return deepmerge(prev, next);
    }, {});
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
    removeKeys,
    merge
});


/***/ }),

/***/ 6320:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/**
 * Transforms multiline string to one liner and trims it
 * e.g. '  this\n is the text    ' → 'this is the text'
 */ const multiLineToOneLine = (string)=>string.replace(/\n\s*|\s{2,}/mg, " ").trim();
/**
 * Capitalizes, transforms first letter to uppercase, string
 * e.g. dumbo → Dumbo
 */ const capitalize = (string)=>string.charAt(0).toUpperCase() + string.slice(1);
/**
 * Decapitalizes, transforms first letter to lowercase, string
 * e.g. ScentType -> scentType
 */ const decapitalize = (string)=>string.split("").map((l, i)=>i === 0 ? l.toLowerCase() : l).join("");
/**
 * Normalizes string and removes all combining diacritical marks
 * e.g. ScentType -> scentType
 */ const normalizeClear = (string)=>string.normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/œ/g, "oe").replace(/æ/g, "ae");
const getFirstLetter = (string)=>{
    const normalizedString = normalizeClear(string).replace(/[^\d\w]/g, "");
    return normalizedString.charAt(0).toUpperCase();
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
    multiLineToOneLine,
    decapitalize,
    capitalize,
    normalizeClear,
    getFirstLetter
});


/***/ }),

/***/ 49950:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  s3: () => (/* binding */ birthdayDate),
  gb: () => (/* binding */ canadaPostalCode),
  hT: () => (/* binding */ date),
  Do: () => (/* binding */ email),
  Nf: () => (/* binding */ futureDate),
  xb: () => (/* binding */ isEmpty),
  BS: () => (/* binding */ maxLength),
  Ei: () => (/* binding */ minLength),
  ZW: () => (/* binding */ nonMilitaryState),
  lX: () => (/* binding */ nonMilitaryZipCode),
  nP: () => (/* binding */ notToday),
  Bj: () => (/* binding */ validators_password),
  XH: () => (/* binding */ passwordMatch),
  m7: () => (/* binding */ phone),
  C1: () => (/* binding */ required),
  ct: () => (/* binding */ requiredRating),
  _F: () => (/* binding */ requiredToBeChecked),
  aX: () => (/* binding */ streetAddress),
  K7: () => (/* binding */ universalPostalCode),
  RX: () => (/* binding */ userName),
  gx: () => (/* binding */ when),
  v0: () => (/* binding */ zipCode)
});

// UNUSED EXPORTS: customRequired, equal, isFieldValueNotEqual

// EXTERNAL MODULE: ./local_modules/date/index.ts
var local_modules_date = __webpack_require__(64895);
;// CONCATENATED MODULE: ./src/helpers/validators/messages.ts
/* harmony default export */ const messages = ({
    required: {
        en: "Required"
    },
    minLength: {
        en: "Must be at least {length} characters"
    },
    maxLength: {
        en: "Must be no more than {length} characters"
    },
    email: {
        en: "Valid email address required"
    },
    date: {
        en: "Date is not valid"
    },
    password: {
        en: "Password must include alphanumeric and !@#$%^&*()_+-= characters"
    },
    pastDate: {
        en: "Date must be in the past"
    },
    birthdayDate: {
        en: "Date must be after 1907"
    },
    futureDate: {
        en: "Date must be in the future"
    },
    notTodayDate: {
        en: "You can’t enter a current date"
    },
    userName: {
        en: "Only letters and spaces are allowed"
    },
    streetAddress: {
        en: "Must be a valid street address"
    },
    zipCode: {
        en: "Must be a valid zip code"
    },
    postalCode: {
        en: "Must be a valid postal code"
    },
    nonMilitary: {
        en: "We don’t ship to US Military APO, FPO & DPO addresses"
    },
    phone: {
        en: "Must be a valid phone number"
    },
    passwordMatch: {
        en: "Passwords should match"
    }
});

;// CONCATENATED MODULE: ./src/helpers/validators/index.ts


// ATTN if you add new validator, then add unit test for it!
// Regular expressions
const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/ // eslint-disable-line
;
const passwordRegex = /^[!@#$%^&*()_+-=A-Za-z0-9]+$/;
const zipCodeRegexp = /^\d{5}([-\s]\d{4})?$/;
const canadaPostalCodeRegex = /^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/;
const militaryZipCodeRegex = /^(340|090|091|092|093|094|095|096|097|098|962|963|964|965|966)\d{2}$/;
const militaryStateRegex = /^(AA|AE|AP)$/i;
const telephoneRegex = /^\+1\s\d{3}\s\d{3}\s\d{2}\s\d{2}$/;
// Helpers
const isEmpty = (value)=>typeof value === "undefined" || value === null || value === "" || /^\s+$/.test(value);
const isValueLengthLessThan = (length, value)=>!isEmpty(value) && String(value).trim().length < length;
const isValueLengthLongerThan = (length, value)=>!isEmpty(value) && String(value).trim().length > length;
const isDateNotValid = (value)=>!isEmpty(value) && !(0,local_modules_date/* default */.ZP)(value).isValid();
const isDateFromPast = (value)=>!isEmpty(value) && (0,local_modules_date/* default */.ZP)(value).isBefore(new Date());
const isDateToday = (value)=>!isEmpty(value) && (0,local_modules_date/* default */.ZP)(value).diff(new Date(), "day") === 0;
const isFieldValueNotEqual = (fieldName)=>(value, values)=>{
        const otherValue = values[fieldName]?.state?.value;
        if (value && otherValue) {
            return value !== otherValue;
        }
    };
// helps add conditional validators
const when = (condition, validators)=>(value, fields)=>{
        const values = Object.keys(fields).reduce((result, key)=>{
            result[key] = fields[key].state.value;
            return result;
        }, {});
        if (condition(values)) {
            let error;
            validators.some((validator)=>{
                error = validator(value, fields);
                if (error) {
                    return true;
                }
            });
            return error;
        }
    };
// Validators
const customRequired = (message)=>(value)=>{
        if (isEmpty(value)) {
            return message;
        }
    };
const required = customRequired(messages.required);
const minLength = (length)=>(value)=>{
        if (isValueLengthLessThan(length, value)) {
            return {
                ...messages.minLength,
                values: {
                    length
                }
            };
        }
    };
const maxLength = (length)=>(value)=>{
        if (isValueLengthLongerThan(length, value)) {
            return {
                ...messages.maxLength,
                values: {
                    length
                }
            };
        }
    };
const email = (value)=>{
    if (!isEmpty(value) && !emailRegex.test(value)) {
        return messages.email;
    }
};
const validators_password = (value)=>{
    if (!isEmpty(value) && !passwordRegex.test(value)) {
        return messages.password;
    }
};
const birthdayDate = (value)=>{
    if (isDateNotValid(value)) {
        return messages.date;
    }
    if (!isEmpty(value)) {
        // workaround to fix 0010 years, because dayjs parses them as 19xx or 20xx
        if (value.match(/\/0{1,3}\d+$/)) {
            return messages.birthdayDate;
        }
        // ATTN pass as param if required
        const date = (0,local_modules_date/* default */.ZP)(value, "MM/DD/YYYY");
        if (date.isAfter(new Date())) {
            return messages.pastDate;
        }
        if (date.isBefore((0,local_modules_date/* default */.ZP)("1907-01-01"))) {
            return messages.birthdayDate;
        }
    }
};
const futureDate = (value)=>{
    if (isDateNotValid(value)) {
        return messages.date;
    }
    if (isDateFromPast(value)) {
        return messages.futureDate;
    }
};
const notToday = (value)=>{
    if (isDateNotValid(value)) {
        return messages.date;
    }
    if (isDateToday(value)) {
        return messages.notTodayDate;
    }
};
const date = (value)=>{
    if (isDateNotValid(value)) {
        return messages.date;
    }
};
const equal = (fieldName, errorMessage)=>(value, values)=>{
        if (isFieldValueNotEqual(fieldName)(value, values)) {
            return errorMessage;
        }
    };
const passwordMatch = (fieldName)=>equal(fieldName, messages.passwordMatch);
const userName = (value)=>{
    const disallowed = /([<>\\/])/i;
    if (disallowed.test(value)) {
        return messages.userName;
    }
};
const streetAddress = (value)=>{
    if (!isEmpty(value) && (/^[A-Za-z]+$/.test(value) || /^[\d\s]+$/.test(value) || !/^[\s\p{Script=Latin}0-9#&.'/-]+$/ui.test(value))) {
        return messages.streetAddress;
    }
};
const zipCode = (value)=>{
    if (!isEmpty(value) && !zipCodeRegexp.test(value)) {
        return messages.zipCode;
    }
};
const canadaPostalCode = (value)=>{
    if (!isEmpty(value) && !canadaPostalCodeRegex.test(value)) {
        return messages.postalCode;
    }
};
const nonMilitaryZipCode = (value)=>{
    if (militaryZipCodeRegex.test(value)) {
        return messages.nonMilitary;
    }
};
const nonMilitaryState = (value)=>{
    if (militaryStateRegex.test(value)) {
        return messages.nonMilitary;
    }
};
const universalPostalCode = (value)=>{
    if (!zipCodeRegexp.test(value) && !canadaPostalCodeRegex.test(value)) {
        return messages.postalCode;
    }
};
const phone = (value)=>{
    if (!isEmpty(value) && !telephoneRegex.test(value)) {
        return messages.phone;
    }
};
const requiredRating = (value)=>{
    const number = Number(value);
    if (!number || number < 1 || number > 5) {
        return messages.required;
    }
};
const requiredToBeChecked = (value)=>{
    if (value !== true) {
        return messages.required;
    }
};


/***/ })

}]);